export default __webpack_public_path__ + "static/media/Apoorva Sharma.5d5dbedf.png";